// extracted by mini-css-extract-plugin
export default {"postSuggestions":"PostSuggestions_postSuggestions__s637f","snippets":"PostSuggestions_snippets__tE5KE"};